import React from 'react';
import { useIntl } from 'react-intl-next';
import { blockMenuMessages } from '@atlaskit/editor-common/messages';
import { SyncBlocksIcon, ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
export var CreateSyncedBlockDropdownItem = function CreateSyncedBlockDropdownItem(_ref) {
  var _api$selection;
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var selection = api === null || api === void 0 || (_api$selection = api.selection) === null || _api$selection === void 0 || (_api$selection = _api$selection.sharedState) === null || _api$selection === void 0 || (_api$selection = _api$selection.currentState()) === null || _api$selection === void 0 ? void 0 : _api$selection.selection;
  if (!(selection !== null && selection !== void 0 && selection.empty)) {
    return null;
  }
  var onClick = function onClick() {
    var _api$core;
    api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 ? void 0 : api.syncedBlock.commands.insertSyncedBlock());
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    elemBefore: /*#__PURE__*/React.createElement(SyncBlocksIcon, {
      label: ""
    }),
    onClick: onClick
  }, formatMessage(blockMenuMessages.createSyncedBlock));
};